import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar:MatSnackBar) { }

  show(style:string='success',message:string,action:boolean = false){
    this.snackBar.openFromComponent(SnackbarComponent,{
      data:{
        style:style,
        message:message,
        action:false
      },
      duration:3000
    })
  }
}
